module.exports = __webpack_public_path__ + "static/foto-marek-aaaaeb81ac76283079e6a637db0d2da2.png";